/*=========================================================================================
  File Name: index.js
  Namespace: app
  Description: Vuex App Store
==========================================================================================*/
import {
  setItemToStorage,
  getItemFromStorage
} from '@/utils/storage.js'

const companies = {
  'a491bc32-c056-4946-9169-cc053387bada': 'INE',
  // '10aecc17-10f4-4af8-ba86-2ad7d101c4c5': 'RMOTR',
  // '225bb15f-4cb5-4e93-bfb5-9634b51ecc6d': 'ELS'
}
const CURRENT_COMPANY = 'current_company_selected'

const state = {
  company: 'a491bc32-c056-4946-9169-cc053387bada',
  allCompanies: companies,
  appVersion: process.env.VUE_APP_VERSION
}

const getters = {
  getSelectedCompany(state) {
    return state.company
  },
  getSelectedCompanyName(state) {
    return companies[state.company]
  },
  getAllCompanies(state) {
    return Object.entries(state.allCompanies).map(([key, value]) => {
      return {label: value, value: key}
    })
  },
  getAppVersion: state => {
    return state.appVersion
  }
}

const mutations = {
  CHANGE_SELECTED_COMPANY(state, company) {
    state.company = company || 'a491bc32-c056-4946-9169-cc053387bada'
  }
}

const actions = {
  changeCompany({ commit }, company) {
    commit('CHANGE_SELECTED_COMPANY', company)
    setItemToStorage(CURRENT_COMPANY, company)
  },
  getCompanyFromStorage({
    commit
  }) {
    const company = getItemFromStorage(CURRENT_COMPANY)
    if (company) {
      commit('CHANGE_SELECTED_COMPANY', company)
    }
  }
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}